import { Col, Row, Select } from 'antd';
import React from 'react';

const { Option } = Select;

const SelectOption = ({ question, selectOption }) => {
  const handleChange = (value) => {
    if (value === undefined || value === null) {
      selectOption(question, null);
    } else {
      const selected = question.options?.find(option => option.value === value);
      selectOption(question, selected);
    }
  };

  return (
    <Row justify='center'>
      <Col xs={24} sm={16} md={12} className='text-center mt-10 mb-10'>
        <Select
          className="cmt-select survey-select-dropdown"
          size="large"
          value={question.selected_option?.value}
          onChange={handleChange}
          placeholder="Seleccione una opción"
          showSearch
          allowClear
          filterOption={(input, option) =>
            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
          }
        >
          {question.options?.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.text}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
  );
};

export default SelectOption;
